import React from 'react';

const SectionDivider = ({ variant = 'wave' }) => {
  if (variant === 'wave') {
    return (
      <div className="relative h-24 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-teal-500/5 to-transparent" />
        <svg className="absolute bottom-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C150,50 350,50 600,30 C850,10 1050,10 1200,30 L1200,120 L0,120 Z" 
                fill="url(#wave-gradient)" 
                className="animate-wave-flow"
                opacity="0.3" />
          <path d="M0,20 C200,60 400,60 600,40 C800,20 1000,20 1200,40 L1200,120 L0,120 Z" 
                fill="url(#wave-gradient)" 
                className="animate-wave-flow-delay"
                opacity="0.2" />
          <defs>
            <linearGradient id="wave-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#14b8a6" stopOpacity="0" />
              <stop offset="50%" stopColor="#14b8a6" stopOpacity="0.6" />
              <stop offset="100%" stopColor="#14b8a6" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    );
  }

  if (variant === 'particles') {
    return (
      <div className="relative h-24 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-teal-400 rounded-full animate-particle-float"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  if (variant === 'line') {
    return (
      <div className="relative h-16 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-teal-500/10 to-transparent animate-shimmer-slow" />
        <div className="relative w-full max-w-4xl h-px">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-teal-500 to-transparent animate-line-expand" />
          <div className="absolute left-0 w-2 h-2 bg-teal-400 rounded-full animate-pulse-dot" style={{ top: '-3px' }} />
          <div className="absolute right-0 w-2 h-2 bg-teal-400 rounded-full animate-pulse-dot" style={{ top: '-3px', animationDelay: '0.5s' }} />
        </div>
      </div>
    );
  }

  if (variant === 'gradient') {
    return (
      <div className="relative h-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-teal-950/20 to-black animate-gradient-pulse" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-full h-px bg-gradient-to-r from-transparent via-teal-500/50 to-transparent" />
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-24 h-24 border-2 border-teal-400/20 rounded-full animate-ring-expand" />
          <div className="absolute inset-0 w-24 h-24 border-2 border-teal-400/30 rounded-full animate-ring-expand-delay" />
        </div>
      </div>
    );
  }

  if (variant === 'pulse') {
    return (
      <div className="relative h-20 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex space-x-2">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="w-1 bg-teal-400 rounded-full animate-pulse-bar"
                style={{
                  animationDelay: `${i * 0.1}s`,
                  height: '40px'
                }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Default - simple fade
  return (
    <div className="relative h-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-teal-500/5 to-transparent animate-fade-pulse" />
    </div>
  );
};

export default SectionDivider;
